var _classCallCheck = require("/var/lib/jenkins/workspace/deploy-prod-frontend/frontend_src_repo/frontend-v1/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/var/lib/jenkins/workspace/deploy-prod-frontend/frontend_src_repo/frontend-v1/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var ALLOCATION_TABLE_SEC_ID_FREE = -1;
var ALLOCATION_TABLE_SEC_ID_END_OF_CHAIN = -2; // eslint-disable-line no-unused-vars
var ALLOCATION_TABLE_SEC_ID_SAT = -3; // eslint-disable-line no-unused-vars
var ALLOCATION_TABLE_SEC_ID_MSAT = -4; // eslint-disable-line no-unused-vars
var AllocationTable = /*#__PURE__*/function () {
  "use strict";

  function AllocationTable(doc) {
    _classCallCheck(this, AllocationTable);
    this._doc = doc;
  }
  _createClass(AllocationTable, [{
    key: "load",
    value: function load(secIds) {
      var _this = this;
      var doc = this._doc;
      var header = doc._header;
      this._table = new Array(secIds.length * (header.secSize / 4));
      return doc._readSectors(secIds).then(function (buffer) {
        for (var i = 0; i < buffer.length / 4; i++) {
          _this._table[i] = buffer.readInt32LE(i * 4);
        }
      });
    }
  }, {
    key: "getSecIdChain",
    value: function getSecIdChain(startSecId) {
      var secId = startSecId;
      var secIds = [];
      while (secId > ALLOCATION_TABLE_SEC_ID_FREE) {
        secIds.push(secId);
        var secIdPrior = secId;
        secId = this._table[secId];
        if (secId === secIdPrior) {
          // this will cause a deadlock and a out of memory error
          break;
        }
      }
      return secIds;
    }
  }]);
  return AllocationTable;
}();
module.exports = AllocationTable;